import { render, staticRenderFns } from "./InventoryLifecycle.vue?vue&type=template&id=12dc8d2c&scoped=true"
import script from "./InventoryLifecycle.vue?vue&type=script&lang=js"
export * from "./InventoryLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc8d2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12dc8d2c')) {
      api.createRecord('12dc8d2c', component.options)
    } else {
      api.reload('12dc8d2c', component.options)
    }
    module.hot.accept("./InventoryLifecycle.vue?vue&type=template&id=12dc8d2c&scoped=true", function () {
      api.rerender('12dc8d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lifecycle/InventoryLifecycle.vue"
export default component.exports